/*
 * @Description:
 * @Author: JiuYue
 * @Date: 2020-10-10 17:18:44
 * @Reference:
 */
const menus = [
  {
    icon: 'home',
    title: '首页',
    path: '/'
  },
  {
    icon: 'user',
    title: '用户管理',
    path: '/model/user'
  },
  {
    icon: 'file-search',
    title: '热词管理',
    path: '/model/hotWord'
  },
  {
    icon: 'exception',
    title: '问题分类',
    path: '/model/problemClass'
  },
  {
    icon: 'question',
    title: '问题管理',
    path: '/model/problemCheck'
  },
  {
    icon: 'book',
    title: '装修日记',
    path: '/model/diary'
  },
  {
    icon: 'ordered-list',
    title: '红黑榜',
    path: '/model/redBlack'
  },
  {
    icon: 'transaction',
    title: '二手交易',
    path: '/model/secondHand'
  },
  {
    icon: 'edit',
    title: '评论管理',
    path: '/model/evalute'
  },
  {
    icon: 'message',
    title: '反馈管理',
    path: '/model/feedBack'
  },
  {
    icon: 'read',
    title: '装修电子书',
    path: '/model/fitmentBook'
  },
  {
    icon: 'file-search',
    title: '关键词屏蔽',
    path: '/model/keyWordShild'
  },
  {
    icon: 'setting',
    title: '基本设置',
    // path: '/bannerSetting'
    children: [
      {
        title: '轮播图',
        path: '/model/banner'
      },
      {
        title: '小程序设置',
        path: '/bannerSetting'
      }
    ]
  }
]
export default menus
